module.exports = __webpack_public_path__ + "img/Rocket.6b307a46.gif";